import { render, staticRenderFns } from "./common-upload.vue?vue&type=template&id=95f1f2da&"
import script from "./common-upload.vue?vue&type=script&lang=js&"
export * from "./common-upload.vue?vue&type=script&lang=js&"
import style0 from "./common-upload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports